module.exports = __webpack_public_path__ + "img/wangshuhong.e762f811.jpg";